<template>
  <div class="jb">

    <div v-for="g in groups" :key="g.title" class="jb-group">
      <div class="jb-gtitle">
        {{g.title}}
        <span v-if="g.note" class="jb-note">{{g.note}}</span>
      </div>

      <div class="jb-grid">
        <div
          v-for="f in visibleFields(g)"
          :key="f.k"
          class="jb-cell"
          :class="['jb-' + f.kind, f.wide ? 'jb-wide' : '', unknownCode(f) ? 'jb-bad' : '']"
        >
          <div class="jb-lab" :title="f.full">{{f.short}}</div>

          <input
            v-if="f.kind === 'date'"
            type="date"
            class="jb-in jb-date"
            v-model="joppdb[f.k]"
            @change="onInput(f)"
          />
          <v-autocomplete
            v-else-if="f.list"
            class="jb-pick"
            :items="itemsFor(f)"
            v-model="joppdb[f.k]"
            dense
            hide-details
            solo
            flat
            :menu-props="{maxHeight: 320}"
            @change="onInput(f)"
          ></v-autocomplete>
          <input
            v-else
            class="jb-in"
            :type="f.text ? 'text' : 'number'"
            v-model="joppdb[f.k]"
            @input="onInput(f)"
          />
        </div>

        <div v-if="g.collapsible && !showRare" class="jb-cell jb-calc jb-more" @click="showRare = true">
          <div class="jb-lab">12.4 &ndash; 12.9</div>
          <div class="jb-in jb-static">{{ rareTotal }} <span class="jb-chev">&#9662;</span></div>
        </div>
      </div>
    </div>

    <div class="jb-foot">
      <span v-if="missingRequired.length" class="jb-warn">
        Obavezno: {{ missingRequired.join(', ') }}
      </span>
      <span v-else class="jb-ok">Sva obavezna polja popunjena</span>
    </div>
  </div>
</template>

<script>
import {joppdStjecatelj, joppdPrimitak, joppdNacinIsplate} from './joppdSifarnici'

export default {
  name: 'joppdbdetailcompact',
  // joppdb is the same object the parent holds - the parent keeps loading, saving
  // and validating, this component only lays the fields out.
  props: {
    joppdb: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      showRare: false,
      lists: {
        stjecatelj: joppdStjecatelj,
        primitak: joppdPrimitak,
        isplata: joppdNacinIsplate,
        notax: []
      },
      // kind: input = operator types it, code = sifarnik value, calc = filled by obracun
      groups: [
        {
          title: 'Stjecatelj',
          fields: [
            {k: 'P2', short: '2 Preb.', full: '2. Šifra općine/grada prebivališta/boravišta', kind: 'input', text: true, req: true},
            {k: 'P3', short: '3 Rad', full: '3. Šifra općine/grada rada', kind: 'input', text: true, req: true},
            {k: 'P4', short: '4 OIB', full: '4. OIB stjecatelja/osiguranika', kind: 'input', text: true, req: true, wide: true},
            {k: 'P5', short: '5 Ime i prezime', full: '5. Ime i prezime stjecatelja/osiguranika', kind: 'input', text: true, req: true, wide: true}
          ]
        },
        {
          title: 'Oznake',
          fields: [
            {list: 'stjecatelj', k: 'P61', short: '6.1 Stjecatelj', full: '6.1. Oznaka stjecatelja/osiguranika', kind: 'code', text: true, req: true},
            {list: 'primitak', k: 'P62', short: '6.2 Primitak', full: '6.2. Oznaka primitka/obveze doprinosa', kind: 'code', text: true, req: true},
            {k: 'P71', short: '7.1 Dod.dop.', full: '7.1. Obveza dodatnog doprinosa za MO za staž s povećanim trajanjem', kind: 'input'},
            {k: 'P72', short: '7.2 Umanjenje', full: '7.2. Oznaka načina umanjenja mjesečne osnovice za obračun doprinosa za MO na temelju generacijske solidarnosti', kind: 'code'},
            {k: 'P8', short: '8 Prvi/zadnji', full: '8. Oznaka prvog/zadnjeg mjeseca u osiguranju po istoj osnovi', kind: 'code'},
            {k: 'P9', short: '9 Radno vrij.', full: '9. Oznaka punog/nepunog radnog vremena ili rada s polovicom radnog vremena', kind: 'code'}
          ]
        },
        {
          title: 'Sati i razdoblje',
          fields: [
            {k: 'P10', short: '10 Sati', full: '10. Ukupni sati rada prema kojima se radi obračun', kind: 'input'},
            {k: 'P100', short: '10.0 Neodrađeni', full: '10.0. Ukupni neodrađeni sati rada (10. - odrađeni sati rada)', kind: 'input'},
            {k: 'P101', short: '10.1 Od', full: '10.1. Razdoblje obračuna od', kind: 'date'},
            {k: 'P102', short: '10.2 Do', full: '10.2. Razdoblje obračuna do', kind: 'date'}
          ]
        },
        {
          title: 'Primitak i doprinosi',
          note: 'računa obračun',
          collapsible: true,
          rare: ['P124', 'P125', 'P126', 'P127', 'P128', 'P129'],
          fields: [
            {k: 'P11', short: '11 Primitak', full: '11. Iznos primitka (oporezivi)', kind: 'calc'},
            {k: 'P12', short: '12 Osnovica', full: '12. Osnovica za obračun doprinosa', kind: 'calc'},
            {k: 'P121', short: '12.1 MIO I', full: '12.1. Doprinos za mirovinsko osiguranje', kind: 'calc'},
            {k: 'P122', short: '12.2 MIO II', full: '12.2. Doprinos za mirovinsko osiguranje - II STUP', kind: 'calc'},
            {k: 'P123', short: '12.3 Zdravstv.', full: '12.3. Doprinos za zdravstveno osiguranje', kind: 'calc'},
            {k: 'P124', short: '12.4 Zaštita', full: '12.4. Doprinos za zaštitu zdravlja na radu', kind: 'calc'},
            {k: 'P125', short: '12.5 Zapošlj.', full: '12.5. Doprinos za zapošljavanje', kind: 'calc'},
            {k: 'P126', short: '12.6 Dod. MO', full: '12.6. Dodatni doprinos za mirovinsko osiguranje za staž osiguranja koji se računa s povećanim trajanjem', kind: 'calc'},
            {k: 'P127', short: '12.7 Dod. MO', full: '12.7. Dodatni doprinos za mirovinsko osiguranje za staž osiguranja koji se računa s povećanim trajanjem', kind: 'calc'},
            {k: 'P128', short: '12.8 Inozem.', full: '12.8. Poseban doprinos za korištenje zdravstvene zaštite u inozemstvu', kind: 'calc'},
            {k: 'P129', short: '12.9 Umanjenje', full: '12.9. Iznos umanjenja mjesečne osnovice za obračun doprinosa za MO na temelju generacijske solidarnosti', kind: 'calc'}
          ]
        },
        {
          title: 'Porez',
          note: 'računa obračun',
          fields: [
            {k: 'P131', short: '13.1 Izdatak', full: '13.1. Izdatak', kind: 'calc'},
            {k: 'P132', short: '13.2 Izd. MO', full: '13.2. Izdatak - uplaćeni doprinos za mirovinsko osiguranje', kind: 'calc'},
            {k: 'P133', short: '13.3 Dohodak', full: '13.3. Dohodak', kind: 'calc'},
            {k: 'P134', short: '13.4 Odbitak', full: '13.4. Osobni odbitak', kind: 'calc'},
            {k: 'P135', short: '13.5 Osnovica', full: '13.5. Porezna osnovica', kind: 'calc'},
            {k: 'P141', short: '14.1 Porez', full: '14.1. Iznos obračunanog poreza na dohodak', kind: 'calc'},
            {k: 'P142', short: '14.2 Prirez', full: '14.2. Iznos obračunanog prireza porezu na dohodak', kind: 'calc'},
            {k: 'P17', short: '17 Primitak', full: '17. Obračunani primitak od nesamostalnog rada (plaća)', kind: 'calc'}
          ]
        },
        {
          title: 'Neoporezivo i isplata',
          fields: [
            {list: 'notax', k: 'P151', short: '15.1 Oznaka neopor.', full: '15.1. Oznaka neoporezivog primitka', kind: 'code', wide: true},
            {k: 'P152', short: '15.2 Iznos', full: '15.2. Iznos neoporezivog primitka', kind: 'input'},
            {list: 'isplata', k: 'P161', short: '16.1 Način isplate', full: '16.1. Oznaka načina isplate', kind: 'code'},
            {k: 'P162', short: '16.2 Za isplatu', full: '16.2. Iznos za isplatu', kind: 'input'}
          ]
        }
      ]
    }
  },
  mounted () {
    // 15.1 uses the neoporezivi primici list the app already keeps in the store
    const notax = this.$store.state.joppdNotax || []
    this.lists.notax = notax.map(n => ({value: n.value, text: n.text}))
  },
  computed: {
    rareTotal () {
      const g = this.groups.find(x => x.collapsible)
      if (!g) { return 0 }
      const sum = g.rare.reduce((s, k) => s + (parseFloat(this.joppdb[k]) || 0), 0)
      return Math.round(sum * 100) / 100
    },
    missingRequired () {
      const out = []
      this.groups.forEach(g => g.fields.forEach(f => {
        if (f.req) {
          const v = this.joppdb[f.k]
          if (v === null || v === undefined || String(v).trim() === '') { out.push(f.short) }
        }
      }))
      return out
    }
  },
  methods: {
    // The sifarnik never blocks a value: if the row already holds a code that is not
    // in the list (older sifarnik, or a typo from before), it is added as an extra
    // entry so it stays visible and is not lost on save.
    // true when the row holds a code that is not in the sifarnik - shown in red so an
    // old wrong oznaka is noticed instead of blending in
    unknownCode (f) {
      if (!f.list) { return false }
      const v = this.joppdb[f.k]
      if (v === null || v === undefined || String(v).trim() === '') { return false }
      if (String(v) === '0' || String(v) === '0000') { return false }
      return !(this.lists[f.list] || []).some(i => String(i.value) === String(v))
    },
    itemsFor (f) {
      const list = this.lists[f.list] || []
      const v = this.joppdb[f.k]
      if (v === null || v === undefined || String(v).trim() === '') { return list }
      const found = list.some(i => String(i.value) === String(v))
      if (found) { return list }
      return [{value: v, text: v + ' (nije u šifarniku)'}].concat(list)
    },
    visibleFields (g) {
      if (!g.collapsible || this.showRare) { return g.fields }
      // 12.4 - 12.9 are zero on almost every line, so they start folded into one cell
      return g.fields.filter(f => g.rare.indexOf(f.k) === -1 || (parseFloat(this.joppdb[f.k]) || 0) !== 0)
    },
    onInput (f) {
      this.$emit('changed', f.k)
    }
  }
}
</script>

<style scoped>
.jb {
  /* one knob for the whole block - everything else is relative to it */
  --fs: 16px;
  font-size: var(--fs);
}
.jb-group { margin-bottom: 10px; }
.jb-gtitle {
  font-size: calc(var(--fs) - 1px);
  color: #616161;
  margin-bottom: 3px;
  border-bottom: 1px solid #eee;
  padding-bottom: 2px;
}
.jb-note { color: #9e9e9e; margin-left: 6px; }
.jb-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 4px;
}
.jb-wide { grid-column: span 2; }
.jb-cell {
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  padding: 2px 5px;
  background: #fff;
  min-width: 0;
}
.jb-code { background: #f3f8ff; border-color: #b3d4fc; }
.jb-calc { background: #fafafa; border-color: transparent; }
.jb-bad { background: #fdecea; border-color: #e57373; }
.jb-bad .jb-lab { color: #c62828; }
.jb-lab {
  font-size: calc(var(--fs) - 2px);
  color: #9e9e9e;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jb-pick >>> .v-input__slot { padding: 0 !important; min-height: 30px !important; background: transparent !important; }
.jb-pick >>> input { font-size: calc(var(--fs) + 1px); }
.jb-in {
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  font-size: calc(var(--fs) + 1px);
  padding: 1px 0;
  color: #212121;
}
.jb-calc .jb-in { color: #616161; }
.jb-date { font-size: var(--fs); }
.jb-static { color: #9e9e9e; }
.jb-more { cursor: pointer; }
.jb-chev { font-size: calc(var(--fs) - 2px); }
.jb-foot { margin-top: 6px; font-size: calc(var(--fs) - 1px); }
.jb-warn { color: #c62828; }
.jb-ok { color: #2e7d32; }
</style>
